import {
  CheckOrderNotificationStore,
  IInspectContainerFormData,
  ITallymanOperationsUIStore,
} from '@tom-ui/planning'
import { OrderResponseDto } from '@tom-ui/planning/app/api'
import { action, makeObservable, observable } from 'mobx'

export class EquipmentSelectionViewStore {
  checkRequest?: NodeJS.Timeout

  constructor(
    private tallymanOperationsUIStore: ITallymanOperationsUIStore,
    private checkNotificationStore: CheckOrderNotificationStore,
  ) {
    makeObservable(this, {
      checkRequest: observable,
      checkOrder: action,
      cancelRequest: action,
    })
  }

  checkOrder = (
    orderData: IInspectContainerFormData,
    order: OrderResponseDto | undefined,
    selectedCraneId?: number,
    selectedGangId?: number,
    isRestow?: boolean,
  ) => {
    this.checkNotificationStore.createCheckInRequest(
      orderData,
      order,
      this.tallymanOperationsUIStore,
      selectedCraneId,
      selectedGangId,
      isRestow,
    )
  }

  cancelRequest = () => {
    clearTimeout(this.checkRequest)
    this.checkRequest = undefined
    this.checkNotificationStore.cancelRequest()
  }
}
